import { MdgpDbApiProxyRef, DomainSystem } from '../api';
import {
  Table,
  TableColumn,
  Breadcrumbs,
  Link,
  Progress,
  ResponseErrorPanel,
  Header,
  HeaderLabel,
  Page,
  Content,
} from '@backstage/core-components';
import useAsync from 'react-use/lib/useAsync';
import { useApi } from '@backstage/core-plugin-api';
import { Grid } from '@material-ui/core';

type DomainSystemsTableProps = {
  systems: DomainSystem[];
};

export const DomainSystemsTable = ({ systems }: DomainSystemsTableProps) => {
  const columns: TableColumn[] = [
    { title: 'System ID', field: 'system_id' },
    { title: 'System Name', field: 'system_name' },
    { title: 'Retrieve Enabled', field: 'system_retrieve_indicator' },
    { title: 'Delete Enabled', field: 'system_delete_indicator' },
    { title: 'System Contact', field: 'system_contact' },
  ];

  return (
    <Page themeId="tool">
      <Header title="MDGP Dashboard" subtitle="Shows current information about the Move Data Governance Pipeline">
        <HeaderLabel label="Owner" value="TBD" />
        <HeaderLabel label="Slack" value="TBD" />
      </Header>
      <Content>
        <Grid container spacing={3} direction="column">
          <Grid item>
            <Breadcrumbs>
              <Link to="/mdgp-dashboard">Home</Link>
            </Breadcrumbs>
          </Grid>
          <Grid item>
            <Table
              title="Active MDGP Domain Systems"
              options={{ search: false, paging: false }}
              columns={columns}
              data={systems}
            />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};

export const DomainSystemsComponent = ({ mockData }: any) => {
  const apiClient = useApi(MdgpDbApiProxyRef);
  const { value, loading, error } = useAsync(async () => {
    if (mockData !== undefined) {
      return mockData.data;
    }

    return apiClient.get<DomainSystem[]>('mdgp-db-api/systems');
  }, []);

  if (loading) {
    return <Progress />;
  } else if (error) {
    return <ResponseErrorPanel error={error} />;
  }

  return <DomainSystemsTable systems={value || []} />;
};
